import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const SuccessStep: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-6 w-full max-w-sm animate-fade-in text-center">
            <div className="rounded-full bg-success-bg p-4 animate-scale-in">
                <CheckCircle2 className="w-12 h-12 text-success-text" />
            </div>

            <div className="space-y-2">
                <h1 className="text-3xl font-bold tracking-tight text-text-primary">
                    ¡Acceso concedido!
                </h1>
                <p className="text-text-secondary">
                    Preparando tu espacio de trabajo...
                </p>
            </div>

            <div className="relative w-12 h-12 mt-8">
                {/* Custom fancy spinner similar to prototype */}
                <div className="absolute inset-0 border-4 border-input-border rounded-full"></div>
                <div className="absolute inset-0 border-4 border-primary rounded-full border-t-transparent animate-spin"></div>
            </div>
        </div>
    );
};
